/**
 *  循环对象，将对象中的值恢复默认
 * @param {*} obj
 * @returns obj
 */
export const resetEmpty = (obj) => {
  for (const key in obj) {
    if (Array.isArray(obj[key])) {
      obj[key] = []
    } else if (typeof obj[key] === 'object') {
      obj[key] = resetEmpty(obj[key]);
    } else {
      obj[key] = '';
    }
  }
  return obj;
}

/**
 * 过滤空参数，返回有值的字段
 * @param params
 * @returns {{}}
 */
export const filterParams = (params) => {
  let newParams = {};
  for (const key in params) {
    if (params[key] !== null && params[key] !== undefined && params[key] !== '') {
      newParams[key] = params[key];
    }
  }
  return newParams;
}


// 回到顶部
export const scrollToTop = (vm) => {
  let el = document.getElementsByClassName("scroller")[1];
  if (el) {
    vm.$nextTick(() => {
      el.scrollTop = 0;
    })
  }
}

// 下载文件
export const downloadFile = (url) => {
  // 创建 a 标签 直接下载
  let a = document.createElement('a');
  a.href = url;
  a.download = url;
  a.click();
  // 下载完成移除a 标签
  // document.body.removeChild(a);
}

/**
 * 将文字写入剪切板
 * @param {string} text
 * @returns {boolean} 返回执行结果
 */
export function exeCommandCopyText(text) {
  return new Promise( (resolve) => {
    navigator.clipboard.writeText(text).then(
      () => resolve(true),
      (err) => {
        console.log(err);
        resolve(false);
      }
    );
  });
}
